// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});
})();


// Jquery

(function ($) { // Begin jQuery
	$(function () { // DOM ready
		// If a link has a dropdown, add sub menu toggle.
		$('nav ul li a:not(:only-child)').click(function (e) {
			$(this).siblings('.nav-dropdown').toggle();
			// Close one dropdown when selecting another
			$('.nav-dropdown').not($(this).siblings()).hide();
			e.stopPropagation();
		});
		// Clicking away from dropdown will remove the dropdown class
		$('html').click(function () {
			$('.nav-dropdown').hide();
		});
		// Toggle open and close nav styles on click
		$('#nav-toggle').click(function () {
			$('nav .nav-list').slideToggle();
		});
		// Hamburger to X toggle
		$('#nav-toggle').on('click', function () {
			this.classList.toggle('active');
		});
	}); // end DOM ready
})(jQuery); // end jQuery